import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { KernelModule } from '../assabil-kernel/kernel.module';
import { ToastrModule } from 'ngx-toastr';
import { LayoutComponent } from './layout/layout.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { WelcomeComponent } from './welcome/welcome.component';
import { AssabilServicesModule } from '../assabil-services/assabil-services.module';
import { AssabilAdminModule } from '../assabil-admin/assabil-admin.module';
import { AssabilSalesModule } from '../assabil-sales/assabil-sales.module';
import { ToolsModule } from '../tools/tools.module';
import { AssabilPackingModule } from '../assabil-packing/assabil-packing.module';


@NgModule({
  declarations: [LayoutComponent, WelcomeComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    ToolsModule,
    AssabilAdminModule,
    AssabilSalesModule,
    AssabilServicesModule,
    AssabilPackingModule,
    KernelModule,
    ToastrModule.forRoot(),
    BsDropdownModule.forRoot(),
  ]
})
export class DashboardModule { }
